import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'page-contact',
  templateUrl: 'contact.html',
  styleUrls: ['./contact.scss'],
  standalone: false,
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    TranslateModule
  ]
})
export class ContactPage {
  public static PATH: string = 'contact';

  constructor() {

  }

}
